<template>
  <div class="scroll">
    <div :class="wrapperClass">
      <div
        v-if="this.alert"
        class="ui simple dimmer"
      >
        <div class="content">
          <div class="center">
            <h2 class="ui inverted icon header">
              <i :class="this.alert.icon" />
              {{ this.alert.title }}
              <div class="sub header">
                {{ this.alert.message }}
              </div>
            </h2>
            <div>
              <button
                class="floated right animated fade pink"
                @click.native="clearAlert"
              >
                <div class="visible content">
                  OK
                </div>
                <div class="hidden content">
                  <i class="ui close icon" />
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div :class="formClass">
        <div
          :class="this.embedded? '' : 'ui segments'"
        >
          <owal-panel
            v-if="!embedded"
            :title="'Add Camera'"
          >
            <owal-form
              :embedded="this.embedded"
              endpoint="/api/v4/cameras"
              :forms="availableProfiles"
              noun="Manufacturer"
              @change="updateSubmission"
              @form-change="form => { this.activeProfile = form }"
            />
          </owal-panel>
          <owal-form
            v-else
            :forms="availableProfiles"
            noun="Manufacturer"
            :embedded="this.embedded"
            @change="updateSubmission"
            @form-change="form => { this.activeProfile = form }"
          />

          <!-- Useful: https://vuejs.org/v2/guide/components.html#Form-Input-Components-using-Custom-Events -->

          <!-- Submit -->
          <div
            v-if="showParameterFields"
            class="ui segment"
          >
            <div class="inline">
              <transition>
                <button
                  v-if="showParameterFields"
                  class="animated fade pink button"
                  @click.native="toggleTemplate()"
                >
                  <div class="visible content">
                    {{ this.activeProfile.template.name }}
                  </div>
                  <div class="hidden content">
                    <i class="ui settings icon" />
                  </div>
                </button>
              </transition>
            </div>
          </div>
        </div>

        <!-- Advanced Settings -->
        <transition>
          <div v-if="showTemplateParameters">
            <div
              v-for="rule in this.templateRules"
              :key="rule.identifier"
              class="ui segment rule"
            >
              <div class="ui top left ribbon label">
                {{ rule.name }}
              </div>
              <div class="ui content fields">
                <owal-form-field
                  v-for="field in rule.fields"
                  :key="activeProfile.identifier + field.identifier"
                  :field="field"
                  :initial-value="parameterValueForField(field)"
                  @change="value => setParameterValueForField(value, field)"
                />
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>
<script>

import { profiles } from '@/libraries/manufacturers/index'
import { upload as uploadCameras } from '@/libraries/api/cameraUpload'
import { inputPanel } from '@/libraries/owal-ui/mixins/inputPanel'
import OwalForm from '@/libraries/owal-ui/forms/OwalForm'
import OwalFormField from '@/libraries/owal-ui/forms/OwalFormField'
import OwalPanel from '@/libraries/owal-ui/panels/OwalPanel'

export default {
  name: 'AddCamera',
  components: { OwalForm, OwalFormField, OwalPanel },
  mixins: [inputPanel],
  data () {
    return {
      activeProfile: '',
      showTemplateParameters: false,
      submitting: false,
      alert: undefined,
    }
  },
  computed: {
    formClass: function () {
      return this.submitting ? 'ui loading form' : 'ui form'
    },
    wrapperClass: function () {
      if (this.alert) {
        return 'ui dimmable dimmed blurring container'
      }
      return 'ui container'
    },
    availableProfiles: function () {
      const profileValues = profiles
      return profileValues
    },
    template: function () {
      return this.activeProfile ? this.activeProfile.template : undefined
    },
    showParameterFields: function () {
      return this.parameterFields.length > 0
    },
    templateRules: function () {
      if (this.activeProfile && this.activeProfile.template && this.activeProfile.template.rules) {
        return this.activeProfile.template.rules.filter(rule => rule.fields.length > 0)
      }
      return []
    },
    parameterFields: function () {
      if (this.activeProfile && this.activeProfile.template) {
        const fields = this.activeProfile.template.parameterFields
        return fields
      }

      return []
    },
  },
  methods: {
    updateSubmission: function (submission) {
      this.submission = submission
      this.$emit('change', submission)
    },
    submit: function () {
      const template = this.activeProfile.template
      const input = this.submission
      let output = template.processSubmission(input)

      if (!Array.isArray(output)) {
        output = [output]
      }

      this.submitting = true

      uploadCameras(output).then(function (response) {
        this.alert = {
          title: 'Upload',
          message: 'Successfully added ' + output.length + ' cameras.',
          icon: 'ui check circle icon',
        }
        this.submitting = false
      }.bind(this))
        .catch(function (error) {
          console.error('Error uploading camera to API. Details: ' + JSON.stringify(error, null, 2))

          this.alert = {
            title: 'Upload',
            message: 'Error code ' + error.response.status + '.',
            error: error,
            icon: 'ui warning sign icon',
          }
          this.submitting = false
        }.bind(this))
    },
    clearAlert: function () {
      this.alert = undefined
    },
    parameterValueForField: function (field) {
      if (this.activeProfile && this.activeProfile.template) {
        const rule = this.activeProfile.template.ruleForId(field.ruleId)

        if (rule && rule.parameters) {
          const parameterValue = rule.parameters.valueForField(field.identifier)
          return parameterValue
        }
      }
      return ''
    },
    setParameterValueForField: function (value, field) {
      if (this.activeProfile && this.activeProfile.template) {
        const rule = this.activeProfile.template.ruleForId(field.ruleId)
        rule.parameters.setValueForField(value, field.identifier)
      }
    },
    toggleTemplate: function () {
      this.showTemplateParameters = !this.showTemplateParameters
    },
  },
}
</script>

<style scoped>
.ui.header {
  margin-top: 16px;
}

#container{
  display: flex;
  flex-direction: column;
  height:100%;
}
.menu{
  flex: initial;
  margin-bottom: 0;
}
.scroll{
  padding-top: 40px;
  padding-bottom: 40px;
  height: 100%;
  overflow-y: auto;
}

.toggle {
  margin-top: 5px;
}

.field {
  padding-top: 7px;
}

.settings-button {
  float: right;
}

</style>
